import { client } from "./client.ts";
import { toast } from "react-toastify";
import { BASE_URL } from "./client.ts";

const base_url = "/inspect-rule";
const file_url = "/file";
const stream_url = "/stream";
const defaultRuleInfo = {
  name: "",
  recipe_keyword: "",
  recipe_location: null,
  recipe_regex: "",
  image_keyword: "",
  image_location: null,
  image_regex: "",
  options: "",
  pre_process: "",
  post_process: "",
  model_uuid: "",
};

// 검사규칙 조회
export const getInspRules = async (params) => {
  try {
    const response = await client.get(base_url, { params });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

// 검사규칙 단일조회
export const getInspRuleDetail = async (id) => {
  try {
    const response = await client.get(`${base_url}/${id}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

// 검사규칙 추가
export const addInspRule = async (ruleInfo) => {
  try {
    const response = await client.post(base_url, {
      ...ruleInfo,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

//  검사규칙 수정
export const editInspRule = async (uuid, ruleInfo) => {
  try {
    const response = await client.patch(`${base_url}/${uuid}`, {
      ...ruleInfo,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// 검사규칙 삭제
export const deleteInspRule = async (uuid) => {
  try {
    const response = await client.delete(`${base_url}/${uuid}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

// 검사현황 전체 조회 - 필터 관련 파라미터 추가 필요
export const getInspStatus = async (params) => {
  try {
    const response = await client.get("/inspect-status", { params });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

// 검사현황 score 목록 조회 (경계값 샘플링용)
export const getInspScores = async (params) => {
  try {
    const response = await client.get("/inspect-status/scores", { params });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

// 리뷰 잔디용 구간 조회 (id 오름차순, 상태 문자열만)
export const getReviewStates = async (params) => {
  try {
    const response = await client.get("/inspect-status/review-states", { params });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

// 검사현황 총 개수 조회
export const getInspStatusCount = async (params) => {
  try {
    const response = await client.get("/inspect-status/count", {
      params,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

// 검사현황 총 개수 스트리밍 조회
export const streamInspStatusCount = (params, onProgress, onComplete, onError) => {
  const filteredParams = Object.fromEntries(Object.entries(params).filter(([_, value]) => value != null));

  const queryString = new URLSearchParams(filteredParams).toString();
  const eventSource = new EventSource(`${BASE_URL}${stream_url}/inspect-status/count/stream?${queryString}`);

  eventSource.onmessage = (event) => {
    try {
      const data = JSON.parse(event.data);
      if (!data.end) {
        onProgress?.(data.count);
      } else {
        onComplete?.(data.count);
        eventSource.close();
      }
    } catch (err) {
      console.error("SSE parse error:", err);
    }
  };

  eventSource.onerror = (err) => {
    onError?.(err);
    eventSource.close();
  };

  return eventSource;
};

// 검사현황 단일 조회
export const getInspStatusDetail = async (uuid) => {
  try {
    const response = await client.get(`/inspect-status/${uuid}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

// 검사현황 이미지 조회
export const getInspStatusImage = async (path) => {
  try {
    const response = await client.get(`${file_url}/download/image?path=${encodeURIComponent(path)}`, {
      responseType: "blob",
    });
    // log(response.data);
    return URL.createObjectURL(response.data);
  } catch (error) {
    console.error(error);
    toast.error("이미지 불러오기를 실패하였습니다.");
  }
};

// threshold로 검사현황 label 변경
export const updateLabelsByThreshold = async (params) => {
  try {
    const response = await client.patch(`/inspect-status/update-labels`, params);
  } catch (error) {
    console.error(error);
    toast.error("이미지 불러오기를 실패하였습니다.");
  }
};

export const updateReviewLabel = async (uuid, label) => {
  try {
    const response = await client.patch(`/inspect-status/${uuid}`, {
      label,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    toast.error("이미지 불러오기를 실패하였습니다.");
  }
};

// 검사현황 이미지 삭제
export const deleteInspStatusImage = async (path) => {
  try {
    const response = await client.post(`/inspect-status/image/delete`, {
      path,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

// 검사현황 이미지 및 데이터 삭제
export const deleteInspStatusImageAndData = async (id, path) => {
  try {
    const response = await client.post(`/inspect-status/image/deleteAll`, {
      id,
      path,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

// 검사규칙 목록 조회
export const getInspectRules = async (value) => {
  try {
    const response = await client.get("/inspect-rule/recipe");
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

// NG 라벨링 목록 조회
export const getNGLabels = async (filterList) => {
  try {
    const response = await client.get("/inspect-status/ng-labels", {
      params: { ...filterList },
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getNGLabelCount = async (filterList) => {
  try {
    const response = await client.get("/inspect-status/ng-label-count", {
      params: { ...filterList },
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

// OK 라벨링 목록 조회
export const getOKRandomLabels = async (filterList, limit) => {
  try {
    const response = await client.get("/inspect-status/ok-labels", {
      params: { ...filterList, limit: limit || 1000 },
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
